import React from 'react'
import styled from 'styled-components'

const Text = styled.span`
  font-family: 'Lucida Console', monospace;
  font-size: 1.12em;
`

class Countdown extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      daysLeft: this.getTimeLeft()
    }
  }
  componentDidMount() {
    this.loop()
  }
  loop = () => {
    this.setState({
      daysLeft: this.getTimeLeft()
    })
    window.requestAnimationFrame(this.loop)
  }
  getTimeLeft() {
    return (new Date('2018-07-01') - new Date()) / 1000 / 60 / 60 / 24
  }
  render() {
    const {daysLeft} = this.state
    return <Text>{daysLeft > 0 ? daysLeft.toFixed(7) : 0}</Text>
  }
}

export default Countdown



// WEBPACK FOOTER //
// ./src/components/countdown.js